import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { orgIdSelector } from "../../../../selectors/orgIdSelector";
import GraphContainer from "./GraphContainer";

const ConnectedGraph = (props) => {
  const {
    dispatchFetchGraph,
    graphData,
    graphParams,
    graphTitle,
    objId,
    orgId,
    refresh,
    selectedInterval,
    windowEnd,
    windowStart,
  } = props;

  useEffect(() => {
    if (objId && orgId && selectedInterval) {
      dispatchFetchGraph({
        objId,
        orgId,
        selectedInterval,
      });
    }
  }, [dispatchFetchGraph, objId, orgId, refresh, selectedInterval]);

  return (
    <GraphContainer
      graphData={[graphData]}
      graphParams={graphParams}
      graphTitle={graphTitle}
      windowEnd={windowEnd}
      windowStart={windowStart}
    />
  );
};

ConnectedGraph.propTypes = {
  dispatchFetchGraph: PropTypes.func.isRequired,
  graphData: PropTypes.shape({}).isRequired,
  graphParams: PropTypes.shape({}).isRequired,
  graphTitle: PropTypes.string,
  objId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  orgId: PropTypes.string.isRequired,
  refresh: PropTypes.bool,
  selectedInterval: PropTypes.shape({}).isRequired,
  windowEnd: PropTypes.string.isRequired,
  windowStart: PropTypes.string.isRequired,
};

ConnectedGraph.defaultProps = {
  graphTitle: "",
  refresh: false,
};

const makeMapStateToProps = (
  _,
  {
    graphDatesSelector,
    graphEntriesSelector,
    graphParamsSelector,
    idSelector,
    intervalSelector,
  }
) => {
  const mapStateToProps = (state) => {
    const graphData = graphEntriesSelector(state);
    const graphParams = graphParamsSelector(state);
    const objId = idSelector(state);
    const orgId = orgIdSelector(state);
    const selectedInterval = intervalSelector(state);
    const { windowEnd = "", windowStart = "" } = graphDatesSelector(state);

    return {
      graphData,
      graphParams,
      objId,
      orgId,
      selectedInterval,
      windowEnd,
      windowStart,
    };
  };

  return mapStateToProps;
};

const makeMapDispatchToProps = (_, { fetchGraph }) => {
  const mapDispatchToProps = (dispatch) => ({
    dispatchFetchGraph: ({ objId, orgId, selectedInterval }) => {
      dispatch(
        fetchGraph({
          insertId: objId,
          objectId: objId,
          orgId,
          selectedInterval,
        })
      );
    },
  });

  return mapDispatchToProps;
};

export default connect(
  makeMapStateToProps,
  makeMapDispatchToProps
)(ConnectedGraph);
